import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import globalSettingsStores from '../../../../../stores/settings-stores';
import { getUserTypeDisplayTextName } from '../../../../../api/types/user/user-type';
import {
  SettingsMappingUsersRolesToDocWithDocNameEntity,
  SettingsUserRoleDocCreatedDefault,
} from '../../../../../api/types/settings/user-document-created-default/settings-user-role-doc-created-default';
import { AddNewDefaultDocumentDialog } from './dialogs/add-new-default-document-dialog';
import { EditDefaultDocumentDialog } from './dialogs/edit-default-document-dialog';
import { DeleteDefaultDocumentDialog } from './dialogs/delete-default-document-dialog';

export const UserDefaultCreationDocuments = observer(() => {
  const [showDialog, setShowDialog] = useState(false);
  const [showEditDialog, setShowEditDialog] = useState(false);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [editingDocument, setEditingDocument] =
    useState<SettingsMappingUsersRolesToDocWithDocNameEntity | null>(null);
  const [deletingDocument, setDeletingDocument] =
    useState<SettingsMappingUsersRolesToDocWithDocNameEntity | null>(null);
  const data = globalSettingsStores.userDefaultDocumentCreation;

  const roleBodyTemplate = (rowData: SettingsUserRoleDocCreatedDefault) => {
    return getUserTypeDisplayTextName(rowData.role);
  };

  const docTypeBodyTemplate = (
    rowData: SettingsMappingUsersRolesToDocWithDocNameEntity,
  ) => {
    return rowData.docTypeName;
  };

  const docNameBodyTemplate = (rowData: SettingsUserRoleDocCreatedDefault) => {
    return rowData.docName;
  };

  const handleEditDocument = (
    document: SettingsMappingUsersRolesToDocWithDocNameEntity,
  ) => {
    setEditingDocument(document);
    setShowEditDialog(true);
  };

  const handleDeleteDocument = (
    document: SettingsMappingUsersRolesToDocWithDocNameEntity,
  ) => {
    setDeletingDocument(document);
    setShowDeleteDialog(true);
  };

  const actionsBodyTemplate = (
    data: SettingsMappingUsersRolesToDocWithDocNameEntity,
  ) => {
    return (
      <div style={{ display: 'flex', gap: '0.5rem' }}>
        <Button
          icon="pi pi-pencil"
          text
          severity="warning"
          tooltip={'עריכת מסמך ברירת מחדל'}
          onClick={() => handleEditDocument(data)}
        />
        <Button
          icon="pi pi-trash"
          text
          severity="danger"
          tooltip={'מחיקת מסמך ברירת מחדל'}
          onClick={() => handleDeleteDocument(data)}
        />
      </div>
    );
  };

  return (
    <div>
      <Button
        style={{ height: '30px', marginTop: '16px', marginBottom: '16px' }}
        label={'הוספה'}
        onClick={() => setShowDialog(true)}
      />
      <DataTable
        value={data}
        emptyMessage={<div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>}
        dataKey="id"
        tableStyle={{
          direction: 'rtl',
        }}
        style={{ width: '100%' }}
      >
        <Column
          field="role.role"
          header="תפקיד"
          body={roleBodyTemplate}
          style={{ textAlign: 'right' }}
        />
        <Column
          field="settingsDocTypeId"
          header="סוג מסמך"
          body={docTypeBodyTemplate}
          style={{ textAlign: 'right' }}
        />
        <Column
          field="docName"
          header="שם מסמך"
          body={docNameBodyTemplate}
          style={{ textAlign: 'right' }}
        />
        <Column field="פעולות" header="" body={actionsBodyTemplate} />
      </DataTable>

      <AddNewDefaultDocumentDialog
        visible={showDialog}
        onHide={() => setShowDialog(false)}
      />

      <EditDefaultDocumentDialog
        visible={showEditDialog}
        onHide={() => {
          setShowEditDialog(false);
          setEditingDocument(null);
        }}
        documentData={editingDocument}
      />

      <DeleteDefaultDocumentDialog
        visible={showDeleteDialog}
        onHide={() => {
          setShowDeleteDialog(false);
          setDeletingDocument(null);
        }}
        documentData={deletingDocument}
      />
    </div>
  );
});
